if (!customElements.get('collection-infinite-scroll')) {
  class CollectionInfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.isLoading = false;
      this.observer = null;
    }

    connectedCallback() {
      this.link = this.querySelector('a[rel="next"]');
      if (!this.link || !('IntersectionObserver' in window)) return;

      this.classList.add('collection-infinite-scroll--enabled');
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async loadNextPage() {
      if (this.isLoading || !this.link) return;

      this.isLoading = true;
      this.classList.add('is-loading');
      const nextUrl = this.link.href;

      try {
        const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Collection page request failed with status ${response.status}`);

        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = page.getElementById('product-grid');
        const currentGrid = document.getElementById('product-grid');
        const nextScroller = page.querySelector('collection-infinite-scroll');

        if (!nextGrid || !currentGrid) throw new Error('Collection product grid was not found');

        const items = Array.from(nextGrid.children);
        items.forEach((item) => {
          if (item.classList.contains('scroll-trigger')) item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));
        });
        currentGrid.append(...items);

        const nextLink = nextScroller ? nextScroller.querySelector('a[rel="next"]') : null;
        if (nextLink) {
          this.link.href = nextLink.href;
          this.isLoading = false;
          this.classList.remove('is-loading');
          return;
        }

        this.remove();
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        this.classList.remove('is-loading');
        this.classList.remove('collection-infinite-scroll--enabled');
        if (this.observer) this.observer.disconnect();
      }
    }
  }

  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
}
